export default "__VITE_ASSET__08d2aae4__"